module.exports = __webpack_public_path__ + "media/miss rabia ielts gif_2.b46666b4.mp4";